import React from 'react';
import { CheckmarkIcon } from './Icons';

export const EULA_ACCEPTED_KEY = 'goodlyfe_eula_accepted';

export const EulaModal = ({ onAccept }: { onAccept: () => void }) => {
    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-black/90 backdrop-blur-md">
            <div className="w-full max-w-2xl bg-gray-900 border border-gray-800 rounded-3xl shadow-2xl flex flex-col max-h-[90vh] overflow-hidden animate-fade-in">
                <div className="p-6 border-b border-gray-800 flex items-center justify-between">
                    <div>
                        <h2 className="text-2xl font-bold text-white mb-1">Standard EULA</h2>
                        <p className="text-gray-400 text-sm">Please review and accept our terms to continue.</p>
                    </div>
                    <div className="w-12 h-12 bg-blue-500/10 rounded-2xl flex items-center justify-center">
                        <CheckmarkIcon className="w-6 h-6 text-blue-400" />
                    </div>
                </div>

                <div className="flex-1 overflow-y-auto p-6 space-y-6 text-gray-300 custom-scrollbar">
                    <section>
                        <h3 className="text-white font-bold mb-2">1. Acceptance of Terms</h3>
                        <p className="text-sm leading-relaxed">By using GoodLyfe, you agree to these terms. If you do not agree, you must not use the application.</p>
                    </section>

                    <section>
                        <h3 className="text-white font-bold mb-2">2. User-Generated Content (UGC) Policy</h3>
                        <p className="text-sm leading-relaxed mb-4">GoodLyfe allows users to share content. You are solely responsible for the content you post. There is <strong>no tolerance for objectionable content or abusive users</strong>.</p>
                        <ul className="list-disc pl-5 space-y-2 text-sm">
                            <li>You may not post content that is defamatory, obscene, pornographic, offensive, or promotes discrimination.</li>
                            <li>You may not harass, threaten, or impersonate other users.</li>
                            <li>All UGC is subject to moderation. We reserve the right to remove any content that violates these terms.</li>
                        </ul>
                    </section>

                    <section>
                        <h3 className="text-white font-bold mb-2">3. Moderation and Enforcement</h3>
                        <p className="text-sm leading-relaxed">We provide tools for users to report objectionable content and block abusive users. Users who violate these terms may be permanently banned without notice.</p>
                    </section>

                    <section>
                        <h3 className="text-white font-bold mb-2">4. Disclaimers</h3>
                        <p className="text-sm leading-relaxed italic">GoodLyfe provides the platform "as is" and is not responsible for the content posted by its users.</p>
                    </section>
                </div>

                <div className="p-6 bg-gray-900 border-t border-gray-800">
                    <button
                        onClick={onAccept}
                        className="w-full py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-2xl transition-all transform active:scale-[0.98] shadow-lg shadow-blue-500/20"
                    >
                        Accept & Continue
                    </button>
                    <p className="text-center text-[10px] text-gray-500 mt-4 uppercase tracking-widest">Acknowledge you have read and agreed to the EULA</p>
                </div>
            </div>
        </div>
    );
};
